/* LMM Merkzettel (Wishlist) — net-new, eigenstaendig neben dem Warenkorb-Drawer.
   - Speicherung ausschliesslich browserseitig in localStorage ("lmm-wishlist-v1"),
     versioniert, variantenscharf, max. 100 Positionen. Keine Kundenkonto-Sync, keine App.
   - Merken-Buttons (Collection, Suche, PDP) sind delegiert an document gebunden
     -> ueberleben den PJAX-Section-Swap der Listen ohne Re-Binding.
   - Beim Oeffnen des Drawers werden Titel/SKU/Preis/Verfuegbarkeit FRISCH von
     /products/<handle>.js geholt. Gespeicherte Snapshots dienen nur als Fallback und
     werden dann sichtbar als "nicht aktualisiert" gekennzeichnet (nie als aktueller Preis).
   - "In den Warenkorb" dupliziert KEINE Warenkorb-Logik: es fuellt ein verstecktes
     form.cartline und laesst den bestehenden lmm-cart-drawer.js-Submit-Handler
     (AJAX /cart/add.js + Drawer oeffnen + Re-Render) die Arbeit machen.
   Wishlist- und Warenkorb-Zustand bleiben getrennt: der Merkzettel kennt keine Cart-Keys,
   der Warenkorb kennt den Merkzettel nicht. */
(function () {
  if (window.__lmmWishlistInit) return;
  window.__lmmWishlistInit = true;

  var KEY = 'lmm-wishlist-v1';
  var VERSION = 1;
  var MAX = 100;
  var MAXQ = 99;

  var root = null, panel = null, body = null, lastFocus = null;
  var memStore = null;          // In-Memory-Fallback, wenn localStorage nicht nutzbar ist
  var memOnly = false;
  var storageNote = '';         // sichtbarer Hinweis, wenn nicht persistiert werden kann
  var openBusy = 0;             // Render-Generation gegen Race bei schnellem Mehrfach-Oeffnen
  var handing = false;          // Doppelklick-Schutz fuer die Warenkorb-Uebergabe

  /* ------------------------------------------------------------------ Utils */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v) { var n = parseInt(v, 10); return isFinite(n) ? n : 0; }
  function clampQty(v) { var n = num(v); if (n < 1) n = 1; if (n > MAXQ) n = MAXQ; return n; }
  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }
  function cfg(name, fallback) {
    var el = document.querySelector('[data-lmm-wd]');
    var v = el ? el.getAttribute('data-' + name) : null;
    return (v == null || v === '') ? fallback : v;
  }
  function money(cents) {
    var cur = cfg('currency', 'EUR');
    var val = (num(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(val);
    } catch (e) {
      return val.toFixed(2).replace('.', ',') + ' ' + cur;
    }
  }
  function netCents(gross) {
    var rate = parseFloat(cfg('vat', '19'));
    if (!isFinite(rate) || rate <= 0) return null;
    return Math.round(num(gross) / (1 + rate / 100));
  }
  /* Produkt-Basispfad ohne Query/Anker — /products/<handle> */
  function baseUrl(u) {
    var s = String(u || '').split('#')[0].split('?')[0].replace(/\/+$/, '');
    return s;
  }
  function imgUrl(src, w) {
    if (!src) return '';
    var s = String(src);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    if (/[?&]width=/.test(s)) return s;
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function announce(msg) {
    var live = document.querySelector('[data-lmm-wish-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 30);
  }

  /* ---------------------------------------------------------------- Storage */
  function empty() { return { v: VERSION, items: [] }; }

  function sanitize(raw) {
    if (!raw || typeof raw !== 'object' || !Array.isArray(raw.items)) return empty();
    var out = [], seen = {};
    for (var i = 0; i < raw.items.length && out.length < MAX; i++) {
      var it = raw.items[i];
      if (!it || typeof it !== 'object') continue;
      var vid = num(it.vid);
      if (!vid || seen[vid]) continue;      // gleiche Variant-ID nie doppelt
      seen[vid] = 1;
      var sn = (it.snap && typeof it.snap === 'object') ? it.snap : {};
      out.push({
        pid: num(it.pid), vid: vid, url: baseUrl(it.url), qty: clampQty(it.qty),
        ts: num(it.ts) || 0,
        snap: {
          t: String(sn.t == null ? '' : sn.t).slice(0, 200),
          s: String(sn.s == null ? '' : sn.s).slice(0, 60),
          img: String(sn.img == null ? '' : sn.img).slice(0, 400),
          price: num(sn.price)
        }
      });
    }
    return { v: VERSION, items: out };
  }

  function read() {
    if (memOnly) return memStore || (memStore = empty());
    var raw;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {                              // localStorage deaktiviert/blockiert
      memOnly = true;
      storageNote = 'Ihr Browser speichert keine lokalen Daten — der Merkzettel gilt nur für diese Sitzung.';
      return memStore || (memStore = empty());
    }
    if (!raw) return empty();
    try {
      return sanitize(JSON.parse(raw));
    } catch (e) {                              // beschaedigtes JSON: sauber verwerfen
      try { window.localStorage.removeItem(KEY); } catch (e2) { /* egal */ }
      return empty();
    }
  }

  function write(data) {
    var d = sanitize(data);
    if (memOnly) { memStore = d; return true; }
    try {
      window.localStorage.setItem(KEY, JSON.stringify(d));
      return true;
    } catch (e) {
      /* Speicher voll: erst ohne Snapshot-Ballast versuchen ... */
      try {
        var slim = {
          v: VERSION, items: d.items.map(function (i) {
            return { pid: i.pid, vid: i.vid, url: i.url, qty: i.qty, ts: i.ts, snap: {} };
          })
        };
        window.localStorage.setItem(KEY, JSON.stringify(slim));
        return true;
      } catch (e2) {
        /* ... sonst in den Speicher ausweichen, damit der Shop bedienbar bleibt. */
        memOnly = true;
        memStore = d;
        storageNote = 'Der lokale Speicher ist voll — Änderungen gelten nur für diese Sitzung.';
        return false;
      }
    }
  }

  function idsSet() {
    var s = {}, its = read().items;
    for (var i = 0; i < its.length; i++) s[its[i].vid] = 1;
    return s;
  }
  function count() { return read().items.length; }
  function findIdx(items, vid) {
    for (var i = 0; i < items.length; i++) if (items[i].vid === vid) return i;
    return -1;
  }

  function addItem(o) {
    var d = read();
    if (findIdx(d.items, o.vid) > -1) return 'exists';
    if (d.items.length >= MAX) return 'full';
    d.items.unshift({
      pid: num(o.pid), vid: num(o.vid), url: baseUrl(o.url), qty: 1, ts: Date.now(),
      snap: { t: o.t || '', s: o.s || '', img: o.img || '', price: num(o.price) }
    });
    write(d);
    return 'added';
  }
  function removeItem(vid) {
    var d = read(), i = findIdx(d.items, num(vid));
    if (i < 0) return false;
    d.items.splice(i, 1);
    write(d);
    return true;
  }
  function setQty(vid, q) {
    var d = read(), i = findIdx(d.items, num(vid));
    if (i < 0) return 1;
    d.items[i].qty = clampQty(q);
    write(d);
    return d.items[i].qty;
  }

  /* -------------------------------------------------------------- UI-Sync */
  function syncCount() {
    var n = count();
    var els = document.querySelectorAll('[data-lmm-wish-count]');
    Array.prototype.forEach.call(els, function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    var trg = document.querySelectorAll('[data-lmm-wish-open]');
    Array.prototype.forEach.call(trg, function (el) {
      el.setAttribute('aria-label', n === 1 ? 'Merkzettel öffnen, 1 Artikel'
        : 'Merkzettel öffnen, ' + n + ' Artikel');
    });
  }

  function btnVid(btn) {
    /* PDP: die Variante steht im Kaufformular und gewinnt gegenueber dem
       serverseitig gerenderten Startwert (Variantenwechsel ohne Reload). */
    var fid = btn.getAttribute('data-wish-form');
    if (fid) {
      var f = document.getElementById(fid);
      var inp = f && f.querySelector('[name="id"]');
      if (inp && inp.value) return num(inp.value);
    }
    return num(btn.getAttribute('data-wish-vid'));
  }

  function syncButtons() {
    var set = idsSet();
    var els = document.querySelectorAll('[data-lmm-wish]');
    Array.prototype.forEach.call(els, function (btn) {
      var on = !!set[btnVid(btn)];
      var title = btn.getAttribute('data-wish-title') || 'Artikel';
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? title + ' vom Merkzettel entfernen'
        : title + ' auf den Merkzettel');
      var lbl = btn.querySelector('[data-wish-label]');
      if (lbl) lbl.textContent = on ? 'Gemerkt' : 'Merken';
    });
  }

  function syncAll() { syncCount(); syncButtons(); }

  /* --------------------------------------------------------- Drawer-Basis */
  function grab() {
    if (!root || !document.body.contains(root)) {
      root = document.querySelector('[data-lmm-wd]');
    }
    panel = root ? root.querySelector('.lmm-wd__panel') : null;
    body = root ? root.querySelector('[data-lmm-wd-body]') : null;
    return root;
  }
  function isOpen() { return !!(root && root.classList.contains('is-open')); }
  function focusables() {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }
  function openDrawer() {
    if (!grab()) return;
    if (!isOpen()) lastFocus = document.activeElement;
    var bd = root.querySelector('.lmm-wd__backdrop'); if (bd) bd.hidden = false;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    Array.prototype.forEach.call(document.querySelectorAll('[data-lmm-wish-open]'), function (el) {
      el.setAttribute('aria-expanded', 'true');
    });
    window.setTimeout(function () { if (panel) { try { panel.focus(); } catch (e) { /* egal */ } } }, 40);
    refreshOpen();
  }
  function closeDrawer() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-lmm-wish-open]'), function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
    if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) {
      try { lastFocus.focus(); } catch (e) { /* egal */ }
    }
  }

  /* ------------------------------------------ frische Storefront-Daten */
  var cache = {};   // url -> Produkt-JSON | null (weg) | undefined (Netzfehler)

  function fetchProduct(url) {
    return fetch(url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) return null;      // Produkt existiert nicht mehr
        if (!r.ok) return undefined;            // unklar -> Snapshot-Fallback
        return r.json();
      })
      .catch(function () { return undefined; });
  }

  /* Kleiner Pool statt 100 paralleler Requests. */
  function loadAll(urls, done) {
    var todo = urls.filter(function (u) { return !(u in cache); });
    if (!todo.length) { done(); return; }
    var idx = 0, active = 0, limit = 6;
    function next() {
      if (idx >= todo.length && active === 0) { done(); return; }
      while (active < limit && idx < todo.length) {
        (function (u) {
          active++;
          fetchProduct(u).then(function (res) {
            cache[u] = res;
            active--;
            next();
          });
        })(todo[idx++]);
      }
    }
    next();
  }

  /* ------------------------------------------------------------- Rendering */
  function stockMarkup(state) {
    if (state === 'available') {
      return '<span class="lmm-wd__stock">Verfügbar</span>';
    }
    if (state === 'sold') {
      return '<span class="lmm-wd__stock lmm-wd__stock--out">Derzeit nicht verfügbar</span>';
    }
    if (state === 'gone') {
      return '<span class="lmm-wd__stock lmm-wd__stock--out">Nicht mehr im Sortiment</span>';
    }
    return '<span class="lmm-wd__stock lmm-wd__stock--unknown">Verfügbarkeit nicht prüfbar</span>';
  }

  function lineHTML(it) {
    var p = cache[it.url];
    var v = null, state = 'unknown', title = it.snap.t, sku = it.snap.s,
      img = it.snap.img, price = it.snap.price, vtitle = '', stale = false, url = it.url;

    if (p === null) {
      state = 'gone';
    } else if (p === undefined) {
      state = 'unknown';                 // Netzfehler -> Snapshot, aber sichtbar markiert
      stale = price > 0;
    } else if (p && p.variants) {
      for (var i = 0; i < p.variants.length; i++) {
        if (num(p.variants[i].id) === it.vid) { v = p.variants[i]; break; }
      }
      if (!v) {
        state = 'gone';                  // Variante entfernt
      } else {
        state = v.available ? 'available' : 'sold';
        title = p.title || title;
        sku = (v.sku == null ? '' : v.sku) || '';
        price = num(v.price);
        vtitle = (p.variants.length > 1 && v.title && v.title !== 'Default Title') ? v.title : '';
        var src = (v.featured_image && v.featured_image.src) || p.featured_image || '';
        img = src ? imgUrl(src, 128) : img;
        url = baseUrl(p.url || it.url) + '?variant=' + it.vid;
      }
    }

    var canAdd = (state === 'available') || (state === 'unknown');
    var h = '';
    h += '<li class="lmm-wd__line' + (state === 'gone' ? ' is-gone' : '') + '" data-vid="' + it.vid + '">';
    h += '<a class="lmm-wd__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">';
    if (img) h += '<img src="' + esc(imgUrl(img, 128)) + '" alt="" width="60" height="60" loading="lazy">';
    h += '</a>';
    h += '<div class="lmm-wd__info">';
    h += '<a class="lmm-wd__name" href="' + esc(url) + '">' + esc(title || 'Artikel') + '</a>';
    if (vtitle) h += '<span class="lmm-wd__variant">' + esc(vtitle) + '</span>';
    if (sku) {
      h += '<span class="lmm-wd__skurow">'
        + '<span class="lmm-wd__sku">Art.-Nr.: <span class="lmm-wd__skuval">' + esc(sku) + '</span></span>'
        + '<button type="button" class="lmm-wd__copy" data-lmm-wish-copy="' + esc(sku) + '"'
        + ' aria-label="Artikelnummer ' + esc(sku) + ' kopieren" title="Artikelnummer kopieren">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">'
        + '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>'
        + '<span class="lmm-wd__copytxt">Kopieren</span></button>'
        + '</span>';
    }
    h += stockMarkup(state);

    if (state !== 'gone') {
      h += '<div class="lmm-wd__row">';
      h += '<div class="lmm-wd__qty" role="group" aria-label="Menge für ' + esc(title) + '">'
        + '<button type="button" data-lmm-wish-qty data-vid="' + it.vid + '" data-to="' + (it.qty - 1) + '"'
        + ' aria-label="Menge verringern"' + (it.qty <= 1 ? ' disabled' : '') + '>&minus;</button>'
        + '<input type="number" class="lmm-wd__qtyval" data-lmm-wish-qtyinput data-vid="' + it.vid + '"'
        + ' value="' + it.qty + '" min="1" max="' + MAXQ + '" inputmode="numeric"'
        + ' aria-label="Menge für ' + esc(title) + '">'
        + '<button type="button" data-lmm-wish-qty data-vid="' + it.vid + '" data-to="' + (it.qty + 1) + '"'
        + ' aria-label="Menge erhöhen"' + (it.qty >= MAXQ ? ' disabled' : '') + '>+</button>'
        + '</div>';
      h += '<div class="lmm-wd__price">';
      if (price > 0) {
        var net = netCents(price);
        h += '<span class="lmm-wd__gross' + (stale ? ' is-stale' : '') + '">' + esc(money(price)) + '</span>';
        if (net != null) h += '<span class="lmm-wd__net">exkl. MwSt. ' + esc(money(net)) + '</span>';
        if (stale) h += '<span class="lmm-wd__stale">gespeicherter Stand, nicht aktualisiert</span>';
      } else {
        h += '<span class="lmm-wd__gross lmm-wd__gross--none">Preis auf Anfrage</span>';
      }
      h += '</div></div>';
      h += '<button type="button" class="lmm-wd__atc" data-lmm-wish-add data-vid="' + it.vid + '"'
        + ' data-title="' + esc(title) + '"' + (canAdd && price > 0 ? '' : ' disabled')
        + '>In den Warenkorb</button>';
    } else {
      h += '<p class="lmm-wd__gonenote">Dieser Artikel ist im Shop nicht mehr abrufbar.</p>';
    }

    h += '</div>';
    h += '<button type="button" class="lmm-wd__remove" data-lmm-wish-remove data-vid="' + it.vid + '"'
      + ' aria-label="' + esc(title || 'Artikel') + ' vom Merkzettel entfernen" title="Entfernen">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">'
      + '<path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/>'
      + '</svg></button>';
    h += '</li>';
    return h;
  }

  function emptyHTML() {
    var u = cfg('empty-url', '/collections/leuchtmittel');
    return '<div class="lmm-wd__empty">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">'
      + '<path d="M12 20s-7-4.35-9.5-8.5C1 8.5 2.5 5.5 5.6 5.5c1.9 0 3.1 1.1 3.9 2.3.8-1.2 2-2.3 3.9-2.3 3.1 0 4.6 3 3.1 6C19 15.65 12 20 12 20Z"/></svg>'
      + '<p>Ihr Merkzettel ist noch leer.</p>'
      + '<p class="lmm-wd__emptyhint">Über das Herz-Symbol an jedem Artikel merken Sie sich Produkte für später.</p>'
      + '<a class="lmm-wd__emptylink" href="' + esc(u) + '">Zum Sortiment</a>'
      + '<a class="lmm-wd__emptylink lmm-wd__emptylink--soft" href="' + esc(rootUrl()) + 'search">Zur Suche</a>'
      + '</div>';
  }

  function paint() {
    grab();
    if (!body) return;
    var d = read();
    var head = root.querySelector('[data-lmm-wd-count]');
    if (head) head.textContent = d.items.length;
    var note = root.querySelector('[data-lmm-wd-note]');
    if (note) {
      if (storageNote) { note.textContent = storageNote; note.removeAttribute('hidden'); }
      else { note.setAttribute('hidden', ''); }
    }
    if (!d.items.length) { body.innerHTML = emptyHTML(); paintError(); syncCount(); return; }
    var h = '<ul class="lmm-wd__lines">';
    for (var i = 0; i < d.items.length; i++) h += lineHTML(d.items[i]);
    h += '</ul>';
    body.innerHTML = h;
    paintError();
    syncCount();
  }

  function refreshOpen() {
    grab();
    if (!body) return;
    var d = read();
    if (!d.items.length) { paint(); return; }
    var gen = ++openBusy;
    if (!body.querySelector('.lmm-wd__lines')) {
      body.innerHTML = '<p class="lmm-wd__loading">Merkzettel wird geladen …</p>';
    }
    var urls = [];
    for (var i = 0; i < d.items.length; i++) {
      if (d.items[i].url && urls.indexOf(d.items[i].url) < 0) urls.push(d.items[i].url);
    }
    loadAll(urls, function () {
      if (gen !== openBusy) return;   // zwischenzeitlich neu geoeffnet/geaendert
      paint();
    });
  }

  /* --------------------------------------------------- Warenkorb-Uebergabe */
  function cartForm() {
    var f = document.getElementById('lmm-wish-cartform');
    if (f) return f;
    f = document.createElement('form');
    f.setAttribute('id', 'lmm-wish-cartform');
    /* .cartline -> wird vom bestehenden lmm-cart-drawer.js-Submit-Handler erkannt */
    f.className = 'cartline lmm-wd__hiddenform';
    f.method = 'post';
    f.action = rootUrl() + 'cart/add';
    f.setAttribute('hidden', '');
    f.innerHTML = '<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">';
    document.body.appendChild(f);
    return f;
  }

  function ownAdd(vid, qty) {
    /* Nur-Fallback: der Warenkorb-Drawer ist nicht geladen. */
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', qty);
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: fd, credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw 0;
      window.location.href = rootUrl() + 'cart';
    }).catch(function () {
      showError('Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.');
    });
  }

  /* Fehlermeldung ueberlebt ein zwischenzeitliches Neuzeichnen (paint() setzt sie erneut). */
  var pendingErr = null;

  function paintError() {
    if (!body || !pendingErr) return;
    var ex = body.querySelector('.lmm-wd__err');
    if (ex) ex.parentNode.removeChild(ex);
    var el = document.createElement('div');
    el.className = 'lmm-wd__err';
    el.setAttribute('role', 'alert');
    el.textContent = pendingErr;
    body.insertBefore(el, body.firstChild);
  }

  function showError(msg) {
    grab();
    pendingErr = msg;
    paintError();
  }
  function clearError() {
    pendingErr = null;
    if (body) {
      var ex = body.querySelector('.lmm-wd__err');
      if (ex) ex.parentNode.removeChild(ex);
    }
  }

  function toCart(vid, qty, title) {
    if (handing) return;
    handing = true;
    window.setTimeout(function () { handing = false; }, 800);
    var f = cartForm();
    f.querySelector('[name="id"]').value = vid;
    f.querySelector('[name="quantity"]').value = clampQty(qty);
    var ok = false;
    if (window.__lmmCartDrawerInit) {
      try {
        if (typeof f.requestSubmit === 'function') { f.requestSubmit(); ok = true; }
        else { ok = !f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
      } catch (e) { ok = false; }
    }
    if (!ok) { ownAdd(vid, clampQty(qty)); return; }
    announce((title || 'Artikel') + ' in den Warenkorb gelegt. Der Artikel bleibt auf dem Merkzettel.');
    closeDrawer();   /* nie zwei Dialoge gleichzeitig — der Warenkorb-Drawer uebernimmt */
  }

  /* ------------------------------------------------------------ Kopieren */
  function copyText(val, btn) {
    function done(okCopy) {
      if (btn) {
        btn.classList.toggle('is-copied', !!okCopy);
        var lbl = btn.querySelector('.lmm-wd__copytxt');
        if (lbl && okCopy) lbl.textContent = 'Kopiert';
        window.setTimeout(function () {
          btn.classList.remove('is-copied');
          if (lbl) lbl.textContent = 'Kopieren';
        }, 1800);
      }
      announce(okCopy ? 'Artikelnummer ' + val + ' kopiert.' : 'Kopieren nicht möglich.');
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(val).then(function () { done(true); }).catch(function () { done(false); });
      return;
    }
    try {
      var ta = document.createElement('textarea');
      ta.value = val;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var okc = document.execCommand('copy');
      document.body.removeChild(ta);
      done(okc);
    } catch (e) { done(false); }
  }

  /* ------------------------------------------------------------- Events */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-lmm-wish-open]');
    if (opener) { e.preventDefault(); openDrawer(); return; }

    if (t.closest('[data-lmm-wd-close]')) { e.preventDefault(); closeDrawer(); return; }

    var wish = t.closest('[data-lmm-wish]');
    if (wish) {
      /* Karten: der Button liegt neben dem Bild-Link — kein Seitenwechsel ausloesen. */
      e.preventDefault();
      e.stopPropagation();
      var vid = btnVid(wish);
      if (!vid) return;
      clearError();
      var title = wish.getAttribute('data-wish-title') || 'Artikel';
      if (idsSet()[vid]) {
        removeItem(vid);
        announce(title + ' vom Merkzettel entfernt.');
      } else {
        var res = addItem({
          pid: wish.getAttribute('data-wish-pid'), vid: vid,
          url: wish.getAttribute('data-wish-url') || location.pathname,
          t: title, s: wish.getAttribute('data-wish-sku') || '',
          img: wish.getAttribute('data-wish-img') || '',
          price: wish.getAttribute('data-wish-price')
        });
        if (res === 'full') {
          /* Kein window.alert: der Drawer oeffnet sich mit einer Fehlerleiste — dort
             kann direkt etwas entfernt werden, statt einen Modaldialog wegzuklicken. */
          var msg = 'Ihr Merkzettel ist voll (maximal ' + MAX + ' Artikel). '
            + 'Bitte entfernen Sie zuerst einen Eintrag.';
          announce(msg);
          openDrawer();
          window.setTimeout(function () { showError(msg); }, 60);
          return;
        }
        announce(title + ' auf den Merkzettel gesetzt.');
      }
      syncAll();
      if (isOpen()) refreshOpen();
      return;
    }

    var rm = t.closest('[data-lmm-wish-remove]');
    if (rm) {
      e.preventDefault();
      clearError();
      var rvid = num(rm.getAttribute('data-vid'));
      var line = rm.closest('.lmm-wd__line');
      var nm = line ? (line.querySelector('.lmm-wd__name') || {}).textContent : '';
      removeItem(rvid);
      announce((nm || 'Artikel') + ' vom Merkzettel entfernt.');
      paint();
      syncButtons();
      var first = panel && panel.querySelector('.lmm-wd__remove, .lmm-wd__emptylink, .lmm-wd__close');
      if (first) { try { first.focus(); } catch (er) { /* egal */ } }
      return;
    }

    var q = t.closest('[data-lmm-wish-qty]');
    if (q) {
      e.preventDefault();
      var to = setQty(q.getAttribute('data-vid'), q.getAttribute('data-to'));
      paint();
      announce('Menge: ' + to);
      return;
    }

    var add = t.closest('[data-lmm-wish-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var avid = num(add.getAttribute('data-vid'));
      var d = read(), i = findIdx(d.items, avid);
      toCart(avid, i > -1 ? d.items[i].qty : 1, add.getAttribute('data-title'));
      return;
    }

    var cp = t.closest('[data-lmm-wish-copy]');
    if (cp) { e.preventDefault(); copyText(cp.getAttribute('data-lmm-wish-copy'), cp); return; }
  });

  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-lmm-wish-qtyinput]');
    if (inp) {
      var to = setQty(inp.getAttribute('data-vid'), inp.value);
      inp.value = to;
      paint();
      announce('Menge: ' + to);
      return;
    }
    /* Variantenwechsel im PDP-Kaufformular -> Merken-Zustand nachziehen. */
    if (e.target && e.target.name === 'id') syncButtons();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Zweiter Tab hat etwas geaendert */
  window.addEventListener('storage', function (e) {
    if (e.key && e.key !== KEY) return;
    cache = {};
    syncAll();
    if (isOpen()) refreshOpen();
  });

  /* Zurueck-Navigation aus dem bfcache: Zustand neu aus dem Speicher lesen */
  window.addEventListener('pageshow', function () { cache = {}; syncAll(); });
  window.addEventListener('pagehide', function () {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });

  /* PJAX-Swap der Listen (lmm-collection.js ersetzt #lmmShop/#lmmMain):
     neu eingefuegte Merken-Buttons bekommen ihren Zustand nachtraeglich. */
  var pending = null;
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (pending) return;
          pending = window.setTimeout(function () { pending = null; syncButtons(); }, 90);
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() { grab(); syncAll(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
